import { render, staticRenderFns } from "./mainCenter1.vue?vue&type=template&id=e73759a6&scoped=true&"
import script from "./mainCenter1.vue?vue&type=script&lang=js&"
export * from "./mainCenter1.vue?vue&type=script&lang=js&"
import style0 from "./mainCenter1.vue?vue&type=style&index=0&id=e73759a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73759a6",
  null
  
)

export default component.exports